













import Vue from 'vue';
import Component from 'vue-class-component'
import {Getter} from 'vuex-class'
import {TotalsSection} from '@/models/LobbyDataResponse.model'
import TotalSubSectionComponent from './TotalSubSection.component.vue'
import {StoreNamespace} from '@/globals/StoreNamespaceGlobal'

@Component({
    components: {
        TotalSubSectionComponent
    }
})
export default class TotalsSectionComponent extends Vue {

    @Getter("totalsSection", StoreNamespace.LOBBY) totalsSection!: TotalsSection;

    mounted() {
        var x = this.totalsSection.totals.filter((value) => {
            return value.noData ? false : value
        })
    }

    noTotalSectionData() {
        return this.totalsSection.totals.filter((value) => {
            return value.noData ? false : value
        })
    }
}

